import { useFileFormMixin } from "../../../../javascript/shared/assetHelpers"
import { dispatchCustomEvent } from "../../../../javascript/shared/helpers"
import fileUploadsPendingUploadController from "../../../file_uploads/assets/javascript/file-uploads-pending-upload-controller"

export default class extends fileUploadsPendingUploadController {
  static targets = ["form", "filename", "cancel", "fileField", "progress"]

  connect() {
    useFileFormMixin(this)
    super.connect()
    App.Helpers.listenToCustomEvent(document, "briefs--file-exchange", this.setFileFieldFiles.bind(this))
  }

  onUploadStart(event) {
    this.initializePendingUploadHandler(event)
  }

  onUploadEnd(event) {
    this.markFileUploadAsCompleteAndSubmit(event)
  }

  initializePendingUploadHandler(event) {
    const { id, file } = event.detail
    if (file === this.file) {
      this.uploadID = id
    }
  }

  submit(event) {
    event && event.preventDefault()
    if (this.fileUploadComplete && !this.submitted) {
      this.submitted = true
      const formDataStr = App.Helpers.formDataAsString(this.formTarget)
      App.Helpers.ajaxRequest({
        url: this.formTarget.action,
        method: "POST",
        data: formDataStr,
        successHandler: this.renderAssetRow.bind(this),
        errorHandler: this.addErrorMessages.bind(this)
      })
    }
  }

  renderAssetRow(response) {
    const { assetsJSON } = response
    dispatchCustomEvent("briefs--file-attachment:success", this.element, { assetsJSON, li: this.element })
  }

  addErrorMessages({ responseText }) {
    this.submitted = false
    const responseObj = JSON.parse(responseText)
    const { name } = responseObj.errors
    if (name) {
      App.Helpers.appendBefore(this.errorBlockFor(name), this.filenameTarget)
    } else {
      this.element.remove()
    }
  }

  errorBlockFor(message) {
    return `<div class="text-error">${message}</div>`
  }

  cancelSubmitIfFileNotUploaded() {
    return !this.fileUploadComplete ? false : true
  }

  markFileUploadAsCompleteAndSubmit(event) {
    const { id } = event.detail
    if (id == this.uploadID) {
      this.fileUploadComplete = true
      this.submit()
    }
  }

  cancel(event) {
    event.preventDefault()
    this.element.remove()
  }

  set filename(val) {
    this.filenameTarget.value = val
  }
}



// WEBPACK FOOTER //
// ./app/components/briefs/assets/javascript/briefs-file-attachment-controller.js